import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-about-us',
	templateUrl: './about-us.component.html',
	styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit, OnDestroy {
	enAboutusBanner = 'assets/images/aboutus/en_aboutus_image.svg';
	arAboutusBanner = 'assets/images/aboutus/ar_aboutus_image.svg';
	kuAboutusBanner = 'assets/images/aboutus/ku_aboutus_image.svg';

	constructor(private api: ApiService, private route: ActivatedRoute, private title: Title, public locale: LocaleService, private auth: AuthService) {}

	embedded: boolean = false;
	queryAdID: string;
	ad: Object;

	ngOnInit(): void {
		console.log(`This About page : ${this.title}`);
		this.title.setTitle(this.locale.translations['aboutus']['n394'] + ' | ' + this.locale.translations['header']['n0']);
		this.route.queryParams.subscribe((queries: Params) => {
			this.queryAdID = queries['adID'];
			this.embedded = queries['embedded'];
		});
	}

	ngOnDestroy(): void {
		this.auth.bootIntercom(false);
	}
}
